<div class="w-auto card-filter-matrix">
   <div class="content-percentage">
     <div class="content-percentage">
       <span *ngFor="let item of SelectedFilterOptions;" [ngClass]="{'active' : ExitsOnArray(item.id), 'selectedHover' : item.id !== ''}" id="{{item.id}}" (click)="item.id !== ''? selectPercentage(item.id) : null" class="">{{item.value}}</span>
     </div>
   </div>
    <div class="footer-buttons">
      <sit-button
      [buttonProperties]="restorebuttonAttributes"
      (click)="sendValues(true)"
        class="mr-05-em"
        style=""
      ></sit-button>
      <sit-button
      [buttonProperties]="applybuttonAttributes"
      (click)="sendValues(false)"
      class=""
      style=""
      ></sit-button>
    </div>
</div>
